define( function() {
	"use strict";

	// Match a standalone tag
	return ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/core/var/rsingleTag.js
// module id = 1840
// module chunks = 37